import { atomWithStorage, createJSONStorage } from "jotai/utils";

import { SELECTED_CATEGORIES_IDS } from "@/constants/browserMemory.constants";

const storage = createJSONStorage<string[]>(() => sessionStorage);

export const selectedCategoriesIdsAtom = atomWithStorage<string[]>(
  SELECTED_CATEGORIES_IDS,
  [],
  storage
);
